import React from 'react';
import LegalDocument from '../components/common/LegalDocument';

const TermsOfService: React.FC = () => {
  return (
      <LegalDocument
          title="Terms of Service"
          lastUpdated="May 23, 2025"
      >
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using XTEA.app (the "Service"), you agree to be bound by these
          Terms of Service (the "Terms"). If you do not agree, you may not use the Service.
        </p>

        <h2>2. Eligibility</h2>
        <p>
          You must be at least 13 years old to access or use our Service.
        </p>

        <h2>3. Account Registration</h2>
        <p>
          Some features may require registration. You agree to provide accurate and complete information
          and to keep it up to date. You are solely responsible for safeguarding your login credentials.
        </p>

        <h2>4. One-Time Purchase and Payment</h2>
        <p>
          Access to certain features or content on XTEA.app may require a one-time purchase. By completing
          a purchase, you agree to pay the listed price in full. All payments are due at the time of purchase.
        </p>

        <h2>5. No Refund Policy</h2>
        <p>
          All purchases made on XTEA.app are final and non-refundable. We do not offer refunds or exchanges
          except where required by law. Please review all product information carefully before purchasing.
        </p>

        <h2>6. User Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Violate any laws or regulations</li>
          <li>Infringe upon intellectual property rights</li>
          <li>Distribute harmful or malicious code</li>
          <li>Attempt unauthorized access to any part of the Service</li>
        </ul>

        <h2>7. Intellectual Property</h2>
        <p>
          All content, features, and functionality on XTEA.app, including text, graphics, logos,
          and software, are the exclusive property of XTEA.app or its licensors and are protected
          by intellectual property laws. You may not reproduce, redistribute, or modify any content
          without our prior written permission.
        </p>

        <h2>8. Modifications to the Service</h2>
        <p>
          We may modify, update, or discontinue the Service at any time without notice. We are not
          liable for any resulting loss or inconvenience.
        </p>

        <h2>9. Disclaimer of Warranties</h2>
        <p>
          The Service is provided "as is" and "as available" without warranties of any kind,
          express or implied, including but not limited to merchantability or fitness for a
          particular purpose.
        </p>

        <h2>10. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, XTEA.app shall not be liable for any
          indirect, incidental, or consequential damages resulting from the use of or
          inability to use the Service.
        </p>

        <h2>11. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of your
          jurisdiction, without regard to its conflict of law principles.
        </p>

        <h2>12. Contact Us</h2>
        <p>
          For questions about these Terms, please contact us at support@xtea.app.
        </p>
      </LegalDocument>
  );
};

export default TermsOfService;
